import React, { useState } from "react";
import Footer from "../componets/Footer";
import NewsHeader from "../componets/NewsHeader";
import Header from "../componets/Header";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import p1 from "../../../../assets/p1.png";
import p2 from "../../../../assets/p2.png";
import p3 from "../../../../assets/p3.png";
import p4 from "../../../../assets/p4.png";
import p5 from "../../../../assets/p5.png";
import p6 from "../../../../assets/p6.png";
import p7 from "../../../../assets/p7.png";
import p8 from "../../../../assets/p8.png";
import p9 from "../../../../assets/p9.png";
import p10 from "../../../../assets/p10.png";
import c1 from "../../../../assets/c1.png";
import c2 from "../../../../assets/c2.jpg";
import c3 from "../../../../assets/c3.png";
import { useNavigate } from "react-router-dom";

const WhyChoose = () => {
  const navigate = useNavigate();
  const [expandedIndexes, setExpandedIndexes] = useState(new Set());
  const cardData = [
    {
      title: "The Podar Prep Teacher",
      description:
        "Our teachers have moved away from 'chalk talk' and other formal teaching methods. At Podar Prep, we understand that high impact evidence-based teaching strategies are the foundation of a child's progression in learning. Our teachers and support staff undergo rigorous quality training to support every child's needs.",
      image: p1,
    },
    {
      title: "Parent Participation",
      description:
        "We believe parents are the required wheel in a child's journey to understand their world. When parents are actively involved in their child's education, it ensures that the child has all the support they need to develop to their full potential.",
      image: p2,
    },
    {
      title: "Where Less Is More Because Naming Is Not Knowing!",
      description:
        "Children can name or recite many things; that is called rote learning. We stress on in-depth conceptual understanding that is project-based, learner-centric approaches that capture learners' interest and boost their ownership of the learning experience.",
      image: p3,
    },
    {
      title: "Interactive S.P.A!",
      description:
        "We have a special room called an Interactive S.P.A that helps nurture well-being and mindfulness in children while giving them the necessary sensory stimulus for creating happy brains.",
      image: p4,
    },
    {
      title: "Foundational Literacy with Symphonics",
      description:
        "Symphonics is a well-researched method that helps children learn about co-relating sounds of the letters using picture cards, stories, puppets, songs and more. Children read and understand simple sentences. They use phonic knowledge to decode regular words and read them aloud accurately.",
      image: p5,
    },
    {
      title: "Foundational Numeracy with Number Magic Program",
      description:
        "This well-researched program encourages children to link numbers with their value, understand spaces and shapes, and understand the concepts of counting, addition and subtraction using number pattern tiles. When number learning happens in a playful and systematic manner, it helps children grasp and relate to future Mathematics learning.",
      image: p6,
    },
    {
      title: "Fun with Coding",
      description:
        "We provide children with the foundation of technology literacy with Coding. We use the 'gifts' designed by the father of Kindergarten, Fredrich Froebel, to develop pre-coding skills like logical thinking, reasoning, problem-solving and looking for patterns, so that they become comfortable with technology from a young age.",
      image: p7,
    },
    {
      title: "Nature-Based Activities",
      description:
        "These activities ensure that our children respect their environment and surroundings; it helps to calm children by providing them with a space to be where they belong. Nature provides countless opportunities for discovery, creativity, problem-solving and STEAM education.",
      image: p8,
    },
    {
      title: "Story and Spiral Curriculum",
      description:
        "We were inspired by Gijubhai Badheka's pedagogy of teaching through stories, as stories develop Higher Order Thinking skills. A story-led curriculum begins with a story and then takes children to explore concepts like colours, shapes, animals, etc. The curriculum is a spiral curriculum inspired by Jerome Bruner's spiral approach. So instead of monthly themes we ensure that themes are continued throughout the year and children move from known to unknown, simple to complex and concrete to abstract.",
      image: p9,
    },
    {
      title: "Assessments at Podar Prep",
      description:
        "We don't rank, grade or number your child at Podar Prep. Instead, we observe and assess children's growth and development using global assessment parameters and share with you the following:",
      image: p10,
    },
  ];
  const advantages = [
    {
      image: c1,
      title: "A Day At Podar Prep",
      description:
        "The daily schedule specifies time periods for different types of activities and routines throughout the day. ",
      path: "/day-at-podar-prep",
    },

    {
      image: c2,
      title: "Unique Activities",
      description:
        "The early childhood programs at Podar Prep are designed to give children the correct stress-free environment, personal attention and scientifically formulated schedule of activities to nurture their growing brains.",
      path: "/unique-activities",
    },
    {
      image: c3,
      title: "Learning Environment",
      description:
        "At Podar Prep we consider the environment to be the Third Teacher (the first and second being the parent and teacher).",
      path: "/learning-environment",
    },
  ];

  const toggleExpand = (index) => {
    setExpandedIndexes((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return (
    <>
      <NewsHeader />
      <Header />
      <Box
        sx={{
          display: "flex",
          textAlign: "center",
          alignItems: "center",
          padding: { xs: 2, md: 2 },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              color: "#005ca8",
              fontSize: { xs: 20, md: 35 },
              fontWeight: "bold",
              fontFamily: '-moz-initial',
              width: { xs: "90%", md: "50%" },
              mx: "auto",
              mt: 5,
            }}
          >
            10 advantages of choosing podar prep for your child
          </Typography>
        </Box>
      </Box>
      <Grid container spacing={2} sx={{ p: { xs: 2, md: 8 } }}>
        {cardData.map((card, index) => {
          const isExpanded = expandedIndexes.has(index);
          const description = isExpanded
            ? card.description
            : card.description.length > 100
            ? card.description.slice(0, 100) + "..."
            : card.description;

          return (
            <Grid
              item
              key={card.title + index}
              xs={12}
              sm={6}
              md={3}
              sx={{ p: 2 }}
            >
              <Box
                sx={{
                  height: isExpanded ? "600px" : "300px",
                  p: 3,
                  boxShadow: 10,
                  borderRadius: 5,
                  textAlign: "center",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  cursor: "default",
                  backgroundColor: "#fff",
                  color: "black",
                  transition: "color 0.3s ease",
                  ":hover": {
                    backgroundColor: "#005ca8",
                  },
                  "&:hover .title": {
                    color: "#f5d44e",
                  },
                  "&:hover .description": {
                    color: "#fff",
                  },
                }}
              >
                <Box>
                  <img
                    src={card.image}
                    alt={card.title}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                      marginBottom: 8,
                    }}
                  />
                  <Typography
                    className="title"
                    sx={{
                      fontSize: 18,
                      fontWeight: "bold",
                      mt: 1,
                      color: isExpanded ? "#005ca8" : "#005ca8",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    className="description"
                    sx={{
                      mb: 1,
                      mt: 2,
                      fontSize: 16,
                      color: isExpanded ? "black" : "black",
                    }}
                    id={`card-description-${index}`}
                    aria-labelledby={`card-toggle-${index}`}
                  >
                    {description}
                  </Typography>
                </Box>

                <Button
                  onClick={() => toggleExpand(index)}
                  sx={{
                    textTransform: "none",
                    fontSize: 18,
                    fontWeight: "bold",
                    color: "#f5d44e",
                  }}
                  aria-expanded={isExpanded}
                  aria-controls={`card-description-${index}`}
                  id={`card-toggle-${index}`}
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </Button>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Box sx={{ py: 6, px: { xs: 2, md: 20 }, backgroundColor: "#d7f9d2" }}>
        <Grid container spacing={4} justifyContent="center">
          {advantages.map((adv, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: 520,
                  backgroundColor: "#ffc93c",
                  borderRadius: 3,
                  boxShadow: 3,
                  textAlign: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={adv.image}
                  alt={adv.title}
                  height="200"
                  sx={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }}
                />
                <CardContent>
                  <Typography
                    sx={{ color: "#005ca8", fontWeight: "bold", fontSize: 22 }}
                  >
                    {adv.title}
                  </Typography>
                  <Typography sx={{ mb: 2, mt: 2 }}>
                    {adv.description}
                  </Typography>
                  <Button
                    onClick={() => navigate(adv.path)}
                    sx={{
                      backgroundColor: "#3652ad",
                      borderRadius: 2,
                      p: 1,
                      color: "#fff",
                    }}
                  >
                    Read More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Footer />
    </>
  );
};

export default WhyChoose;

